// material design
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// entzy resources
import configEntzy from "components/config/ConfigEntzy";
import { ModuleSubHeaderTag } from "components/utils/common/CommonTags";

function MemberMessagingFooter() {
  return (
    <Box className="box-default" sx={{ mt: configEntzy.APP_SPACING_HL }}>
      <ModuleSubHeaderTag text="Content Minimalism Tips" />
      <Box className="box-inline" sx={{ maxWidth: 300, margin: "0 auto" }}>
        <Typography variant="body2" color="textSecondary" align="center">
          Aim for short conversations focussed on getting together. No need for
          content generation here. Use quick online interactions as a means to
          facilitate getting offline.
        </Typography>
      </Box>
    </Box>
  );
}

export default MemberMessagingFooter;
